package com.appcreator.dto

import kotlinx.serialization.Serializable

@Serializable
class UpdateResponse(
    val success: Boolean
)